module.exports = __webpack_public_path__ + "components/flag/static/square/rw-cce4b394af77f02026491c1bf35fd5db.svg";